module.exports = __webpack_public_path__ + "img/bg2.22f2ec77.png";